<template>
    <div class="ad ad-referral aside__item aside__item__selectable">
        <div class="text-center">
            <div class="ad__header">
                <h2>{{$t('Реферальная программа')}}</h2>
            </div>
            <div class="ad__body" v-html="$t('invite-text')">
            </div>
            <div class="ad__footer">
                <a href="/profile/referral" title="Реферальная программа" class="btn btn-success">{{$t('Узнать больше')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AsideReferralBanner',
};
</script>

<style scoped>

</style>

<i18n>
{
    "ru": {
        "invite-text": "Capitalist приглашает <br /> всех желающих <br /> поучаствовать в нашей <br /> реферальной программе."
    },
    "en": {
        "invite-text": "Capitalist invites everyone <br/> to participate in our referral program.",
        "Реферальная программа": "Referral program",
        "Узнать больше": "Read more"
    }
}
</i18n>
